<template>
  <div class="voucher">
    <el-dialog
      title="查看"
      :visible.sync="checkVisible"
      :append-to-body="true"
      width="90%">
      <voucherCheck v-if="currentBatchId && gamesList" :batch_id="currentBatchId" :gamesList="gamesList"/>
    </el-dialog>
    <el-dialog :title="text + '优惠券'" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="派发类型:" label-width="120px" prop="name">
          <el-radio-group v-model="form.dispatch_type">
            <el-radio :label="0">免费</el-radio>
            <el-radio :label="1">付费</el-radio>
            <el-radio :label="2">首充</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="批次名称:" label-width="120px" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="适用游戏:" label-width="120px" prop="game_id">
          <el-select v-model="form.game_id" placeholder="请选择游戏">
            <el-option v-for="item in gamesList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" label-width="120px" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型" @change="changeType">
            <el-option label="现金券" :value="0"></el-option>
            <el-option label="折扣券" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.type" label="最大减免金额：" label-width="120px" required>
          <el-input placeholder="最大减免金额" v-model="form.max_discount">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="面值：" label-width="120px" prop="value">
          <el-select v-if="form.type" v-model="form.value" placeholder="请选择折扣券面值">
            <el-option v-for="num in discount" :key="num" :label="num" :value="num"></el-option>
          </el-select>
          <el-input v-else placeholder="现金券面值" v-model="form.value">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="满减额度：" label-width="120px" prop="amount">
          <el-input placeholder="可用满减额度" v-model="form.amount">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <template v-if="form.dispatch_type === 2">
          <el-form-item label="活动时间:" label-width="120px" prop="activerange">
            <el-date-picker
              v-model="form.activerange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="失效时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="有效期：" label-width="120px" prop="valid_days">
            <el-input placeholder="请输入" v-model="form.valid_days">
              <template slot="prepend">获得后</template>
              <template slot="append">天内</template>
            </el-input>
          </el-form-item>
          <el-form-item label="每人数量：" label-width="120px" prop="user_quantity">
            <el-input placeholder="每个用户发放的数量" v-model="form.user_quantity">
              <template slot="append">张</template>
            </el-input>
          </el-form-item>
        </template>
        <template v-else-if="form.dispatch_type === 1">
          <el-form-item label="价格：" label-width="120px" prop="price">
            <el-input placeholder="请输入" v-model="form.price">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="有效期：" label-width="120px" prop="valid_days">
            <el-input placeholder="请输入" v-model="form.valid_days">
              <template slot="prepend">获得后</template>
              <template slot="append">天内</template>
            </el-input>
          </el-form-item>
          <el-form-item label="充值条件：" label-width="120px" prop="buy_requirement">
            <el-input placeholder="累计充值金额 >= XX" v-model="form.buy_requirement">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="限购条件：" label-width="120px" prop="buy_limit_type">
            <el-radio-group v-model="form.buy_limit_type">
              <el-radio-button :label="0">不限</el-radio-button>
              <el-radio-button :label="1">每天</el-radio-button>
              <el-radio-button :label="2">每周</el-radio-button>
              <el-radio-button :label="3">每月</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.buy_limit_type" label-width="120px" prop="buy_limit">
            <el-input
              placeholder="限购数量"
              v-model="form.buy_limit">
              <template slot="append">张</template>
            </el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="有效时间:" label-width="120px" prop="timerange">
            <el-date-picker
              v-model="form.timerange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="失效时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户ID：" label-width="120px">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="一行一个用户ID"
              v-model="form.to_users">
            </el-input>
          </el-form-item>
          <el-form-item label="每人数量：" label-width="120px" prop="user_quantity">
            <el-input placeholder="每个用户发放的数量" v-model="form.user_quantity">
              <template slot="append">张</template>
            </el-input>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
    <commonTable
      ref="commonTable"
      url="/admin/coupon_batches/list"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
      :advancedSearchColumn="advancedSearchColumn"
      @reset="reset"
    >
      <template #search>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="onAdd()"
          >新增</el-button>
      </template>
      <el-table-column label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            plain
            @click="onEdit(scope.row)"
            v-if="scope.row.status === 0"
            >编辑</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click="onCheck(scope.row)"
            >查看</el-button>
          <el-button
            type="warning"
            size="small"
            plain
            @click="onRecycle(scope.row)"
            v-if="hasPermission('批次回收') && scope.row.status === 1"
            >回收</el-button
          >
          <el-button
            type="success"
            size="small"
            plain
            @click="onPass(scope.row)"
            v-if="hasPermission('批次通过') && scope.row.status === 0"
            >通过</el-button
          >
          <el-button
            type="danger"
            size="small"
            plain
            @click="onReject(scope.row)"
            v-if="hasPermission('批次拒绝') && scope.row.status === 0"
            >拒绝</el-button
          >
        </template>
      </el-table-column>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import _ from 'lodash'

import commonTable from '@/component/commonTable.vue'
import voucherCheck from './voucherCheck.vue'

export default {
  name: 'voucher',
  data () {
    return {
      currentBatchId: null,
      checkVisible: false,
      isEdit: '',
      discount: [
        1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9
      ],
      form: {
        name: '',
        game_id: '',
        type: '',
        value: '',
        amount: '',
        max_discount: '',
        dispatch_type: 0,
        // 免费
        timerange: [],
        to_users: '',
        user_quantity: '',
        // 收费
        price: '',
        valid_days: '',
        buy_requirement: '',
        buy_limit_type: '',
        buy_limit: '',
        // 首充
        activerange: [],
      },
      dialogVisible: false,
      typeList: [],
      statusList: [],
      gamesList: [],
      advancedSearchColumn: [
        {
          label: "面值/折扣",
          prop: "value",
          type: "input",
        },
        {
          label: "类型",
          prop: "type",
          type: "select",
          option: [
            {
              value: 0,
              label: '现金券'
            },
            {
              value: 1,
              label: '折扣券'
            },
          ]
        },
        {
          label: "审核时间起+审核时间止",
          prop: "verified_from+verified_to",
          type: "date",
          timerange: []
        },
      ],
      rules: {
        name: [
          { required: true, message: '批次名称', trigger: 'blur' }
        ],
        game_id: [
          { required: true, message: '请选择游戏', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        value: [
          { required: true, message: '请填写现金券面值', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请填写满减额度', trigger: 'blur' }
        ],
        user_quantity: [
          { required: true, message: '请填写用户发放数量', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请填写价格', trigger: 'blur' }
        ],
        valid_days: [
          { required: true, message: '请填写有效期', trigger: 'blur' }
        ],
        buy_requirement: [
          { required: true, message: '请填写充值条件', trigger: 'blur' }
        ],
        buy_limit: [
          { required: true, message: '请填写限购数量', trigger: 'blur' }
        ],
        activerange: [
          { required: true, message: '请选择活动日期', trigger: 'change' }
        ],
      }
    }
  },
  computed: {
    text () {
      return this.isEdit !== '' ? '编辑' : '新增'
    },
    column () {
      return [
        {
          label: "ID",
          prop: "id",
          fixed: true
        },
        {
          label: "批次名称",
          prop: "name",
          fixed: true
        },
        {
          label: "面值/折扣",
          prop: "value"
        },
        {
          label: "有效期",
          prop: "valid_date",
          formatter: (row) => {
            const { valid_at, invalid_at, valid_days, dispatch_type  } = row
            if (dispatch_type) {
              return `获得后${valid_days}天`
            }
            let result = ''
            if (valid_at) result += valid_at + ' ~ '
            if (invalid_at) result += invalid_at
            return result || '--'
          }
        },
        {
          label: "适用游戏",
          prop: "game_id",
          formatter: (row, column, cellValue) => {
            const findItem = this.gamesList && this.gamesList.find(item => item.value === Number(cellValue))
            return findItem ? findItem.label : cellValue
          }
        },
        {
          label: "满减额度",
          prop: "amount",
        },
        {
          label: "类型",
          prop: "type",
          formatter: (row, column, cellValue) => {
            const findItem = [
              {
                value: 0,
                label: '现金券'
              },
              {
                value: 1,
                label: '折扣券'
              },
            ].find(item => item.value === Number(cellValue))
            return findItem ? findItem.label : cellValue
          }
        },
        {
          label: "价格",
          prop: "price",
        },
        {
          label: "充值条件（元）",
          prop: "buy_requirement",
        },
        {
          label: "限购条件",
          prop: "buy_limit",
          formatter: (row, column, cellValue) => {
            const { buy_limit_type, dispatch_type  } = row
            if (!dispatch_type) return '--'
            return buy_limit_type ? `每${['天', '周', '月'][buy_limit_type - 1]}${cellValue}张` : '不限'
          }
        },
        {
          label: "操作时间",
          prop: "updated_at",
        },
        {
          label: "操作人",
          prop: "creator.name",
        },
        {
          label: "状态",
          prop: "status",
          formatter: (row, column, cellValue) => {
            const findItem = [
              {
                value: 0,
                label: '审核中'
              },
              {
                value: 1,
                label: '已通过'
              },
              {
                value: 2,
                label: '不通过'
              },
              {
                value: 3,
                label: '已回收'
              }
            ].find(item => item.value === Number(cellValue))
            return findItem ? findItem.label : cellValue
          }
        },
        {
          label: "审核时间",
          prop: "verified_at",
        },
        {
          label: "审核人",
          prop: "verifier.name",
        },
      ]
    }, 
    searchColumn () {
      return [
        {
          label: "批次名称",
          prop: "name",
          type: "input",
        },
        {
          label: "适用游戏",
          prop: "game_id",
          type: "select",
          option: this.gamesList
        },
        {
          label: "状态",
          prop: "status",
          type: "select",
          option: [
            {
              value: 0,
              label: '审核中'
            },
            {
              value: 1,
              label: '已通过'
            },
            {
              value: 2,
              label: '不通过'
            },
            {
              value: 3,
              label: '已回收'
            }
          ]
        },
        {
          label: "有效时间起+有效时间止",
          prop: "valid_from+valid_to",
          type: "date",
          timerange: []
        },
      ]
    }
  },
  methods: {
    changeType () {
      this.form.value = ''
    },
    resetForm () {
      this.form = {
        name: '',
        game_id: '',
        type: '',
        value: '',
        amount: '',
        max_discount: '',
        dispatch_type: 0,
        // 免费
        timerange: [],
        to_users: '',
        user_quantity: '',
        // 收费
        price: '',
        valid_days: '',
        buy_requirement: '',
        buy_limit_type: '',
        buy_limit: '',
        // 首充
        activerange: [],
      }
    },
    submitForm () {
      let flag = true
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          flag = false
          return false
        }
      })
      if (!flag) return
      const data = {}
      const form = _.cloneDeep(this.form)
      const timerange = form.timerange
      const activerange = form.activerange
      const typeKeyList = [
        ['to_users', 'user_quantity'],
        ['price', 'valid_days', 'buy_requirement', 'buy_limit_type', 'buy_limit'],
        ['valid_days', 'user_quantity'],
      ]
      const submitKey = [
        'name',
        'game_id',
        'type',
        'value',
        'amount',
        'max_discount',
        'dispatch_type'].concat(typeKeyList[form.dispatch_type])
      form.to_users = form.to_users ? form.to_users.split('\n').map(item => Number(item)) : []
      for (let key in form) {
        if (submitKey.includes(key)) data[key] = form[key]
      }
      if (!form.dispatch_type && form.timerange && form.timerange.length === 2) {
        data['valid_at'] = timerange[0]
        data['invalid_at'] = timerange[1]
      }
      if (form.dispatch_type === 2 && form.activerange && form.activerange.length === 2) {
        data['start_at'] = activerange[0]
        data['end_at'] = activerange[1]
      }
      let url = 'create'
      if (this.isEdit !== '') {
        url = 'update'
        data['id'] = this.isEdit
      }
      fetch({
        url: `/admin/coupon_batches/${url}`,
        method: "POST",
        data
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: this.text + "成功",
          })
          this.resetForm()
          this.$refs["form"].clearValidate()
          this.$refs["commonTable"].reload()
          this.dialogVisible = false
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          })
        }
      })
    },
    onCheck ({ id }) {
      this.currentBatchId = id
      this.checkVisible = true
    },
    onReject ({ id }) {
      this.$confirm('是否确定拒绝该优惠券?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetch({
          url: "/admin/coupon_batches/reject",
          method: "POST",
          data: {
            id
          }
        }).then((res) => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: "已拒绝",
            })
            this.$refs["commonTable"].reload()
          }
        })
      })
    },
    onPass ({ id }) {
      this.$confirm('是否确定通过该优惠券?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetch({
          url: "/admin/coupon_batches/verify",
          method: "POST",
          data: {
            id
          }
        }).then((res) => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: "已通过",
            })
            this.$refs["commonTable"].reload()
          }
        })
      })
    },
    onRecycle ({ id }) {
      this.$confirm('是否确定回收该优惠券?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetch({
          url: "/admin/coupon_batches/recover",
          method: "POST",
          data: {
            id
          }
        }).then((res) => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: "已回收",
            })
            this.$refs["commonTable"].reload()
          }
        })
      })
    },
    onAdd () {
      this.isEdit = ''
      this.resetForm()
      this.dialogVisible = true
    },
    onEdit (item) {
      this.resetForm()
      const data = {}
      const form = _.cloneDeep(this.form)
      for (let key in form) {
        if (!_.isNil(item[key]) && item[key] !== '') {
          let value = item[key]
          if (key === 'to_users') {
            value = item[key].join('\n')
          } else if (_.isFinite(Number(value))) {
            value = Number(value)
          }
          data[key] = value
        }
      }
      if (item['valid_at'] && item['invalid_at']) {
        data['timerange'] = [
          item['valid_at'],
          item['invalid_at']
        ]
      }
      if (item['start_at'] && item['end_at']) {
        data['activerange'] = [
          item['start_at'],
          item['end_at']
        ]
      }
      this.isEdit = item.id
      this.form = data
      this.dialogVisible = true
    },
    // 重置
    reset() {
      this.advancedSearchColumn.forEach(item => {
        if (item.type === 'date' && item.timerange) {
          if (item.timerange) item.timerange = []
          if (item.activerange) item.activerange = []
        }
      })
      this.searchColumn.forEach(item => {
        if (item.type === 'date') {
          if (item.timerange) item.timerange = []
          if (item.activerange) item.activerange = []
        }
      })
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        }
      })
    },
  },
  async mounted () {
    await this.getGameSelectList()
  },
  components: {
    commonTable,
    voucherCheck
  }
}
</script>

<style lang="less" scoped>

</style>
